import { provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import * as Sentry from '@sentry/angular';
import { environment } from '@et/environment';
import { getDocPrepServiceDomain } from '@et/utils';

Sentry.init({
  dsn: environment.sentryElsiDns,
  environment: environment.environment,
  enabled: environment.production,
  integrations: [Sentry.browserTracingIntegration()],
  tracePropagationTargets: [
    'localhost',
    getDocPrepServiceDomain(),
    environment.apiServer.domain,
    environment.docio.domain,
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: environment.environment === 'prod' ? 1.0 : 0,
});

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .catch((err) => console.error(err));
